// API Configuration - Update these when connecting to real backend

const API_CONFIG = {
  // TODO: Update with real backend URL
  BASE_URL: process.env.REACT_APP_API_URL || "http://localhost:3001/api",

  // Request timeout in milliseconds
  TIMEOUT: 30000,

  // Number of retry attempts for failed requests
  RETRY_ATTEMPTS: 3,

  // Auth configuration
  AUTH: {
    HEADER_NAME: "Authorization",
    TOKEN_PREFIX: "Bearer ",
    TOKEN_KEY: "authToken",
    REFRESH_TOKEN_KEY: "refreshToken",
    USER_DATA_KEY: "userData",
  },

  // Feature flags
  FEATURES: {
    ENABLE_LOGGING: process.env.NODE_ENV === "development",
    ENABLE_MOCK_DATA: process.env.REACT_APP_USE_MOCK_DATA === "true",
    ENABLE_OFFLINE_SUPPORT: false,
    ENABLE_CACHING: true,
  },

  // Error codes mapping
  ERROR_CODES: {
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    VALIDATION_ERROR: 422,
    SERVER_ERROR: 500,
  },

  // Default headers for all requests
  DEFAULT_HEADERS: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },

  // Cache settings
  CACHE: {
    USER_PROFILE_TTL: 5 * 60 * 1000, // 5 minutes
    GAME_LIST_TTL: 2 * 60 * 1000, // 2 minutes
    GAME_DETAILS_TTL: 30 * 1000, // 30 seconds
  },

  // Retry configuration
  RETRY: {
    ATTEMPTS: 3,
    DELAY: 1000, // Base delay in ms
    MULTIPLIER: 2, // Exponential backoff multiplier
    MAX_DELAY: 10000, // Maximum delay between retries
  },

  // File upload settings
  UPLOAD: {
    MAX_FILE_SIZE: 5 * 1024 * 1024, // 5MB
    ALLOWED_IMAGE_TYPES: ["image/jpeg", "image/png", "image/webp"],
    CHUNK_SIZE: 1024 * 1024, // 1MB chunks
  },

  // Pagination defaults
  PAGINATION: {
    DEFAULT_LIMIT: 20,
    MAX_LIMIT: 100,
  },
};

export default API_CONFIG;
